"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = exports.useBaseUrl = void 0;
let baseUrl = "";
const defaultPreset = "preset:sharp/resize:fit:972/gravity:sm/quality:70/plain";
function useBaseUrl(url) {
    baseUrl = stripSlashes(url);
}
exports.useBaseUrl = useBaseUrl;
const stripSlashes = (string) => string.replace(/^\/|\/$/g, "");
function transform(url, definition = defaultPreset) {
    if (url === undefined || url === null) {
        return null;
    }
    definition = stripSlashes(definition);
    url = stripSlashes(url);
    const b64 = Buffer.from(url).toString("base64");
    return `${baseUrl}/${definition}/${b64}`;
}
exports.transform = transform;
//# sourceMappingURL=index.js.map